import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { customerHomePath } from '../../lib/customerHome';

const Search = () => {
  const location = useLocation();
  return <Navigate to={`${customerHomePath}${location.search}`} replace />;
};

export default Search;
